/**
 * Route Service Context
 *
 * 通过 React Context 将 IRouteService 注入到组件树中，
 * 业务模块可通过 useRoute() hook 获取路由服务实例。
 */
import { createContext, useContext } from 'react';
/** 路由服务 Context */
export const RouteServiceContext = createContext(null);
/**
 * useRoute Hook
 *
 * 获取路由服务实例，业务模块通过此 hook 访问路由能力：
 * ```tsx
 * import { useRoute } from '@hvsin/mod-route'
 *
 * function MyPage() {
 *   const { Link, useParams, useNavigate } = useRoute()
 *   const { id } = useParams<{ id: string }>()
 *   // ...
 * }
 * ```
 */
export function useRoute() {
    const service = useContext(RouteServiceContext);
    if (!service) {
        throw new Error('[useRoute] RouteService not found in context. ' +
            'Make sure route-mod is loaded and app is wrapped with RouteServiceProvider.');
    }
    return service;
}
//# sourceMappingURL=route-context.js.map